import { DatePipe } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    templateUrl: './stacked-footer.component.html',
    selector: 'stacked-footer-bar',
    imports: [DatePipe]
})
export class StackedFooterComponent extends AppComponentBase implements OnInit {

    today = new Date();
    releaseDate: string;
    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    constructor(
        injector: Injector
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.releaseDate = this.appSession.application.releaseDate.toFormat('YYYYMMDD');
    }
}
